import { Panel } from './Panel';
import { RadioButton } from '../ui';
import { LoadContext } from "../../../utils";
import { Settings } from "../../../settings";
import { Focusable, InteractiveWrapper } from "../../../ui";
import { Game } from '../../../game';

export class Hints extends Panel
{
    private noneButton:RadioButton;
    private someButton:RadioButton;
    private extraButton:RadioButton;

    public static preload() {
        LoadContext.current.add('Settings', './assets/accessibility/Settings{size}.json');
    }

    constructor( game:Game )
    {
        super(
            game,
            "Hints",
            {
                title: "CYB_Panel3_Hints",
                explain: 'CYB_Panel3_HintsYesNo',
                settings: 'CYB_Panel3_HintsChoice',
            },
            {width: 504, height: 360},
            true
        );

        // const icon:Sprite = new Sprite( LoadContext.current.getSpritesheet('Settings').textures['icon_hints'] );
        // icon.position.set( this.icon_x, this.icon_y );
        // this.addChild( icon );

        this.noneButton = new RadioButton( "No Hints", {fontName: 'AsapMedium', fontSize: 30 } );
        this.noneButton.position.set( 160, 142 );
        this.disposables.add(new InteractiveWrapper(this.noneButton, {
            onHover: () => {
                this.playRadioHover( this.noneButton, "CYB_Panel3_NoHints" );
            },
            onFocus: () => {
                this.playRadioHover( this.noneButton, "CYB_Panel3_NoHints", true );
            },
            onTap: () => {
                this.game.vo.stop();
                this.setHintValue(Settings.HintFrequency.NONE);
                this.game.logEvent("change_setting", "hints_none");
                this.playRadioVO( this.noneButton, "CYB_Panel3_NoHints" );
            }
        }));
        this.addChild( this.noneButton );

        this.someButton = new RadioButton( "Some Hints", {fontName: 'AsapMedium', fontSize: 30});
        this.someButton.position.set( 160, 208 );
        this.disposables.add(new InteractiveWrapper(this.someButton, {
            onHover: () => {
                this.playRadioHover( this.someButton, "CYB_Panel3_SomeHints" );
            },
            onFocus: () => {
                this.playRadioHover( this.someButton, "CYB_Panel3_SomeHints", true );
            },
            onTap: () => {
                this.game.vo.stop();
                this.setHintValue(Settings.HintFrequency.SOME);
                this.game.logEvent("change_setting", "hints_some");
                this.playRadioVO( this.someButton, "CYB_Panel3_SomeHints" );
            }
        }));
        this.addChild( this.someButton );

        this.extraButton = new RadioButton("Extra Hints", {fontName: 'AsapMedium', fontSize: 30});
        this.extraButton.position.set( 160, 276 );
        this.disposables.add(new InteractiveWrapper(this.extraButton, {
            onHover: () => {
                this.playRadioHover( this.extraButton, "CYB_Panel3_ExtraHints" );
            },
            onFocus: () => {
                this.playRadioHover( this.extraButton, "CYB_Panel3_ExtraHints", true );
            },
            onTap: () => {
                this.game.vo.stop();
                this.setHintValue(Settings.HintFrequency.EXTRA);
                this.game.logEvent("change_setting", "hints_extra");
                this.playRadioVO( this.extraButton, "CYB_Panel3_ExtraHints" );
            }
        }));
        this.addChild( this.extraButton );

        this.updateToMatchSetting();
    }

    private setHintValue( value:Settings.HintFrequency )
    {
        this.noneButton.active = value === Settings.HintFrequency.NONE;
        this.someButton.active = value === Settings.HintFrequency.SOME;
        this.extraButton.active = value === Settings.HintFrequency.EXTRA;

        if( value != this.settings.hintFrequency.value ) {
            this.settings.hintFrequency.value = value;
        }
    }

    getFocusItems():Focusable[]
    {
        let items = super.getFocusItems();
        return items.concat( [ this.noneButton, this.someButton, this.extraButton ] );
    }

    updateToMatchSetting()
    {
        super.updateToMatchSetting();
        this.setHintValue( this.settings.hintFrequency.value );
    }

    destroy()
    {
        super.destroy();
    }
}